import { MutableRefObject, useRef } from 'react';
import useUnmount from './useUnmount';

const useMounted = (): MutableRefObject<boolean> => {
    const mountedRef = useRef<boolean>(true);

    useUnmount(() => {
        mountedRef.current = false;
    });

    return mountedRef;
};

export default useMounted;
